



































import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import WarningExclamation from '../../../assets/svg/warningExclamation.vue'
import Check from '../../../assets/svg/greenCheck.vue'
import DangerExclamation from '../../../assets/svg/dangerExclamation.vue'
import { ToastState } from '../../../types/interfaces'

@Component({
  components: {
    WarningExclamation,
    DangerExclamation,
    Check
  }
})
export default class Toast extends Vue {
  @Prop({ required: true }) visible!: boolean
  @Prop({ default: '' }) headerText!: string
  @Prop({ default: '' }) bodyText!: string
  @Prop({ default: ToastState.WARNING }) state!: ToastState

  alreadyShown = false

  @Watch('visible', { immediate: true })
  updateAlreadyShown (alreadyShown: boolean) {
    if (alreadyShown) {
      this.alreadyShown = true
    }
  }

  get ToastState () {
    return ToastState
  }

  confirmToast () {
    this.$emit('confirmation')
  }
}
